import React, { useContext, useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

import FinancialScheduleTable, {
  FinancialScheduleTableProps,
} from './FinancialScheduleTable';
import NewSchedule from './NewSchedule';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AuthContext } from './Auth/Auth';
import ButtonOperation from './ButtonOperation';
import IPaymentschedule from 'icons/IPaymentschedule';

export type FinancialScheduleModalProps = Pick<
  ModalProps,
  'onCancel' | 'visible'
> &
  FinancialScheduleTableProps & {
    data?: any;
    controller?: React.ReactElement;
    currcode?: string;
    phase?: string;
    global?: boolean;
    comcode: string;
    loading?: boolean;
    flagretailer?: boolean;
  };

const FinancialScheduleModal = ({
  finElement,
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  currcode,
  global,
  data,
  phase,
  comcode,
  loading,
  flagretailer,
  ...otherProps
}: FinancialScheduleModalProps) => {
  const [visible, setVisible] = useState(false);
  const { isInspect } = useContext(AuthContext);


  console.log('finElement',finElement)

  return (
    <>
      {controller && !isInspect ? (
        React.cloneElement(controller, {
          onClick: (ev: any) => {
            ev.stopPropagation();
            !isInspect && setVisible(true);
          },
        })
      ) : (
        <ButtonOperation
          size="large"
          comcode={comcode}
          icon={
            <IPaymentschedule
              color="blue"
              height="17px"
              width="16px"
              onClick={(ev: any) => {
                isInspect && setVisible(true);
              }}
            />
          }
          onClick={(ev: any) => {
            ev.stopPropagation();
            !isInspect && setVisible(true);
          }}
        />
      )}
      <Modal
        className="modal-sfs"
        title={
          <GetLabel label="psTable.title" Inspectstyle={{ width: '98%' }} />
        }
        footer={null}
        width={1400}
        style={{ top: '20px', height: '400px' }}
        open={controller ? visible : visibleProp}
        onCancel={
          controller
            ? (ev: any) => {
                ev.stopPropagation();
                setVisible(false);
              }
            : onCancelProp
        }
        {...otherProps}
      >
        {global ? (
          <NewSchedule
            currcode={currcode}
            allElements={data ?? {}}
            loading={ loading}
            flagretailer={flagretailer}
          />
        ) : (
          <FinancialScheduleTable
            currcode={currcode}
            finElement={finElement}
            phase={phase}
            loading={loading}
            flagretailer={flagretailer}
          />
        )}
      </Modal>
    </>
  );
};

export default FinancialScheduleModal;
